import { render, staticRenderFns } from "./PrognoseResultaat.vue?vue&type=template&id=43e5a8f8"
import script from "./PrognoseResultaat.vue?vue&type=script&lang=js"
export * from "./PrognoseResultaat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports